function ErrorMessage({ children }) {
	return children.map((error, i) => (
		<div key={i} className="invalid-feedback d-block">
			{error}
		</div>
	));
}

export default ErrorMessage;
